import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@nextui-org/modal';

import { Button } from '@nextui-org/react';
import React from 'react';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader className="pb-2">
          <h3 className="text-lg font-bold text-slate-800">Confirm Removal</h3>
        </ModalHeader>
        <ModalBody>
          <p className="text-sm text-slate-600">
            Are you sure you want to remove this partner? This action cannot be
            undone.
          </p>
        </ModalBody>
        <ModalFooter className="pt-2">
          <Button
            variant="bordered"
            onClick={onClose}
            radius="sm"
            className="border-slate-300 text-slate-600"
            isDisabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={onConfirm}
            radius="sm"
            isLoading={isLoading}
          >
            Remove Partner
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteConfirmationModal;
